import { render, staticRenderFns } from "./EnviarEntradasView.vue?vue&type=template&id=50c051b7"
import script from "./EnviarEntradasView.vue?vue&type=script&setup=true&lang=js"
export * from "./EnviarEntradasView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports